import React, { forwardRef } from 'react'

import MaskedInput, { MaskedInputProps } from '../MaskedInput/MaskedInput'

export interface ArcadePasswordInputProps extends Omit<MaskedInputProps, 'type' | 'autoComplete'> {
  showPasswordLabel: string
  hidePasswordLabel: string
  isInvalid?: boolean
  isNewPassword: boolean
}

const ArcadePasswordInput = forwardRef<HTMLInputElement, ArcadePasswordInputProps>(
  ({ showPasswordLabel, hidePasswordLabel, isInvalid = false, isNewPassword, ...restProps }, ref) => {
    return (
      <MaskedInput
        showPasswordLabel={showPasswordLabel}
        hidePasswordLabel={hidePasswordLabel}
        isInvalid={isInvalid}
        type="password"
        autoComplete={isNewPassword ? 'new-password' : 'current-password'}
        ref={ref}
        {...restProps}
      />
    )
  }
)

export default ArcadePasswordInput
